import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_URL from '../../ServiceModule/Service';

// Async Thunk for fetching events
export const fetchEvents = createAsyncThunk('events/fetchEvents', async () => {
  const response = await axios.get(`${API_URL}/event/readAllEvents`);

  if (response.data.data.length > 0) {
  }
  return response.data.data;
});

// Async Thunk for fetching an event by ID
export const getEventById = createAsyncThunk(
  'events/getEventById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/event/readOneEvents?event_id=${id}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async Thunk for adding an event
export const addEvent = createAsyncThunk(
  'events/addEvent',
  async (eventData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/event/createEvents`, eventData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async Thunk for updating an event
export const updateEvent = createAsyncThunk(
  'events/updateEvent',
  async (eventData, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${API_URL}/event/updateEvents`, eventData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async Thunk for deleting an event
export const deleteEvent = createAsyncThunk(
  'events/deleteEvent',
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}/event/deleteEvents?event_id=${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Events slice
const eventsSlice = createSlice({
  name: 'events',
  initialState: {
    events: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    // Handle fetching events
    builder.addCase(fetchEvents.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchEvents.fulfilled, (state, action) => {
      state.loading = false;
      state.events = action.payload;
    });
    builder.addCase(fetchEvents.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Handle fetching an event by ID
    builder.addCase(getEventById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEventById.fulfilled, (state, action) => {
      state.loading = false;
      state.selectedEvent = action.payload;
    });
    builder.addCase(getEventById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Handle adding an event
    builder.addCase(addEvent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addEvent.fulfilled, (state, action) => {
      state.loading = false;
      state.events.push(action.payload);
    });
    builder.addCase(addEvent.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Handle updating an event
    builder.addCase(updateEvent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateEvent.fulfilled, (state, action) => {
      state.loading = false;
      const index = state.events.findIndex((event) => event.id === action.payload.id);
      if (index !== -1) {
        state.events[index] = action.payload;
      }
    });
    builder.addCase(updateEvent.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Handle deleting an event
    builder.addCase(deleteEvent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteEvent.fulfilled, (state, action) => {
      state.loading = false;
      state.events = state.events.filter((event) => event.id !== action.payload);
    });
    builder.addCase(deleteEvent.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default eventsSlice.reducer;
